import { combineReducers } from 'redux';
import auth from './login-reducer'

const appReducers = combineReducers({
    auth
})

export default appReducers;